import { useTranslate } from '@tolgee/react';
import { GetStaticProps } from 'next';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React from 'react';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import Container from '@amf/shared/components/layout/Container';
import ContactSend from '@amf/shared/components/contact/ContactSend';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';

interface ContactPageProps extends NavigationProps {}

export default function ContactPage({ navigation, partners }: ContactPageProps) {
  const { t } = useTranslate();
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <div className='ContactPage'>
        <Layout navigation={navigation} partners={partners}>
          <Meta title={t('contact.title')} />
          <Container>
            <h1>{t('contact.title')}</h1>
            <div className='ContactPage__content'>
              <ContactSend buttonProps={{ variant: 'dark' }} />
              <div className='ContactPage__info'>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.info.title')}</h2>
                  <address>
                    Plzeňský malý fotbal, z.s.
                    <br />
                    Tylova 473/27, Jižní Předměstí, 301 00 Plzeň
                  </address>
                  <p>
                    <a href='mailto:info@pzmf.cz'>info@pzmf.cz</a>
                    <br />
                    <a href='tel:+420723660895'>+420 723 660 895</a>
                  </p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.billing.title')}</h2>
                  <address>
                    <strong>Plzeňský malý fotbal, z.s.</strong>
                    <br />
                    Tylova 473/27, Jižní Předměstí
                    <br />
                    301 00 Plzeň
                  </address>
                  <p>IČ: 05533732</p>
                  <p>{t('contact.billing.account')}: 55337321/5500</p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.social.title')}</h2>
                  <p>
                    <a
                      href='https://www.facebook.com/plzenskymalyfotbal'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Facebook
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </Container>
        </Layout>
      </div>
    </GoogleReCaptchaProvider>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
    revalidate: 10,
  };
};
